<app-page-breadcrumb pageTitle="Tamaños de Empresa"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Controls -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <div class="flex items-center gap-1.5">
    </div>
    <div class="flex items-center gap-1.5">
      <button
        *appHasPermission="'companies:create'"
        type="button"
        (click)="nuevo()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nuevo Tamaño
      </button>
    </div>
  </div>

  <!-- Loading -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando tamaños...</span>
  </div>
  }

  <!-- Error -->
  @if (error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Tabla -->
  @if (!loading && !error) {
  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="max-w-full overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Min. Empleados</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Max. Empleados</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (items.length === 0) {
          <tr>
            <td colspan="4" class="px-5 py-8 text-center">
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                </svg>
                <span>No hay tamaños de empresa registrados</span>
              </div>
            </td>
          </tr>
          }
          @for (item of items; track item.id) {
          <tr>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="block font-medium text-gray-800 dark:text-white/90">{{ item.name }}</span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              @if (item.minEmployees != null) {
              {{ item.minEmployees }}
              } @else {
              <span class="text-xs text-gray-400 dark:text-gray-500 italic">—</span>
              }
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              @if (item.maxEmployees != null) {
              {{ item.maxEmployees }}
              } @else {
              <span class="text-xs text-gray-400 dark:text-gray-500 italic">—</span>
              }
            </td>
            <td class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
              <div class="flex items-center justify-center gap-2">
                <button *appHasPermission="'companies:edit'" (click)="editar(item)"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                  title="Editar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                  </svg>
                </button>
                <button *appHasPermission="'companies:delete'" (click)="eliminar(item)"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                  title="Eliminar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }
</div>
